import React from 'react';
import { DiamondIcon } from './icons/Icons';
export function Divider() {
  return <div className="flex items-center justify-center gap-4 py-2" aria-hidden="true" data-id="element-39" data-mp="1gbihlmjszxfu">
      <span className="h-px w-16 sm:w-28 bg-white/25" data-id="element-40" data-mp="1l2ickm9d45fp" />
      <DiamondIcon className="w-3 h-3 text-white/50" data-id="element-41" data-mp="1l3tiosqa5p9z" />
      <span className="h-px w-16 sm:w-28 bg-white/25" data-id="element-42" data-mp="1q1bpodkqlufc" />
    </div>;
}